import React from 'react'
import { ExpertPhoneNumberBySlugComponent } from '#src/generated/graphql'
import { Avatar, Grid, GridItem } from '@deal/components'
import { Experiment, Variation } from '@deal/experiment-js'
import { IdentityConsumer } from '#src/containers/Identity'

import styles from './styles.css'

interface Props {
  categorySlug: string | null
}

// Taken from https://stackoverflow.com/questions/8358084/regular-expression-to-reformat-a-us-phone-number-in-javascript
const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = phoneNumber.toString().replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = match[1] ? '+1 ' : ''
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return null
}

const CallExpertBanner: React.SFC<Props> = ({ categorySlug }) => {
  return (
    <IdentityConsumer>
      {({ myself }) => {
        // HACK: If a category slug is being used and it isn't 'charters' don't render anything.
        // This is to prevent landing pages other than charters from rendering this banner
        // Also don't query for expert if user is not logged in. Quick fix until API is updated to support guest users
        if (!myself || !categorySlug || categorySlug !== 'charters') return null
        return (
          <ExpertPhoneNumberBySlugComponent variables={{ slug: categorySlug }}>
            {({ data }) => {
              if (
                data &&
                data.categoryBySlug &&
                data.categoryBySlug.recommendExpertForConsumer.expert &&
                data.categoryBySlug.recommendExpertForConsumer.expert.assignedPhone
              ) {
                const {
                  assignedPhone,
                  displayName,
                  shortName,
                  expertProfile
                } = data.categoryBySlug.recommendExpertForConsumer.expert
                const expertName = displayName
                return (
                  <Experiment id="personalized-call-banner" default="off">
                    <Variation id="on">
                      <div className={styles.banner}>
                        <Grid>
                          <GridItem col={2}>
                            {expertProfile && expertProfile.profilePhoto && (
                              <Avatar
                                name={expertName}
                                size={64}
                                src={expertProfile.profilePhoto.url}
                                className={styles.avatar}
                              />
                            )}
                            <div className={styles.details}>
                              <div className={styles.number}>
                                {formatPhoneNumber(assignedPhone)}
                              </div>
                              <div className={styles.text}>
                                Call or text your charter expert, {shortName}, to help plan your
                                next escape.
                              </div>
                            </div>
                          </GridItem>
                        </Grid>
                      </div>
                    </Variation>
                    <Variation id="off">
                      <div className={styles.simpleBanner}>
                        <Grid>
                          <GridItem col={2}>
                            <div className={styles.number}>{formatPhoneNumber(assignedPhone)}</div>
                            <div className={styles.simpleText}>
                              Call or text. Your free dedicated charter expert is here to help plan
                              your next escape.
                            </div>
                          </GridItem>
                        </Grid>
                      </div>
                    </Variation>
                  </Experiment>
                )
              } else {
                return null
              }
            }}
          </ExpertPhoneNumberBySlugComponent>
        )
      }}
    </IdentityConsumer>
  )
}

export default CallExpertBanner
